import { combineReducers } from 'redux';
import reportLibraryReducer from './reportLibrary';
import reportGeneratorReducer from './reportGenerator';
import sideBarReducer from './sideBar';
import reportReducer from './report';
import reportSectionsReducer from './reportSections';
import reportDetailsReducer from './reportDetails';
import riskScoreReducer from './riskScore';
import clientsReducer from './clients';
import policyReducer from './paansIntegration';
import userReducer from './userReducer';
import applicationProfileReducer from './applicationProfile.reducer';
import userManagementReducer from './userManagement';

export default combineReducers({
    sideBar: sideBarReducer,
    reportLibrary: reportLibraryReducer,
    reportGenerator: reportGeneratorReducer,
    report: reportReducer,
    reportSections: reportSectionsReducer,
    riskScore: riskScoreReducer,
    reportDetails: reportDetailsReducer,
    clients: clientsReducer,
    paansIntegration: policyReducer,
    user: userReducer,
    applicationProfile: applicationProfileReducer,
    userManagement: userManagementReducer,
})
